import { render, staticRenderFns } from "./OrganizationFileErrorsTable.vue?vue&type=template&id=1b31ff18"
import script from "./OrganizationFileErrorsTable.vue?vue&type=script&lang=ts"
export * from "./OrganizationFileErrorsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports